export default {
    DOCUMENT_TYPE: 'DOCUMENT_TYPE',
    COUNTRY_OF_BIRTH: 'COUNTRY_OF_BIRTH',
    NATIONALITY: 'NATIONALITY',
    PERSONAL_IDENTIFIER: 'PERSONAL_IDENTIFIER',
    POSTAL_CODE: 'POSTAL_CODE',
    ADDRESS_NUMBER: 'ADDRESS_NUMBER',
    ADDRESS_COUNTRY_NAME: 'ADDRESS_COUNTRY_NAME',
    ADDRESS_CITY: 'ADDRESS_CITY',
    BANK_ACCOUNT_NUMBER: 'BANK_ACCOUNT_NUMBER',
    FIRST_NAME: 'FIRST_NAME',
    DOCUMENT_EXPIRY_DATE: 'DOCUMENT_EXPIRY_DATE',
    ADDRESS_STREET: 'ADDRESS_STREET',
    DOCUMENT_NUMBER: 'DOCUMENT_NUMBER',
    DATE_OF_BIRTH: 'DATE_OF_BIRTH',
    LAST_NAME: 'LAST_NAME',
    PROMO_CODE: 'PROMO_CODE',
    EMAIL: 'EMAIL',
    MOBILE: 'MOBILE'
}